import React from 'react';

const Button = ({ children, variant = 'primary', size = 'md', className = '', disabled = false, ...props }) => {
  const baseClasses = 'inline-flex items-center justify-center font-semibold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#09090B] disabled:opacity-50 disabled:cursor-not-allowed shadow-sm';
  
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2.5 text-xs tracking-wide',
    lg: 'px-6 py-3.5 text-sm tracking-wide',
  };

  const variantClasses = {
    primary: 'bg-[#F97316] text-[#FFFFFF] hover:bg-[#FB923C] focus:ring-[#F97316] shadow-[0_2px_15px_rgba(249,115,22,0.35)]',
    secondary: 'bg-[#121215] text-[#FFFFFF] border border-[#27272A] hover:bg-[#1A1A1E] hover:border-[#9CA3AF]/40 focus:ring-[#27272A]',
    outline: 'border border-[#F97316] text-[#F97316] hover:bg-[#F97316]/15 focus:ring-[#F97316]',
    success: 'bg-[#10B981] text-[#09090B] hover:bg-[#34D399] font-bold focus:ring-[#10B981] shadow-[0_2px_15px_rgba(16,185,129,0.35)]',
    danger: 'bg-[#EF4444] text-[#FFFFFF] hover:bg-[#F87171] focus:ring-[#EF4444] shadow-[0_2px_15px_rgba(239,68,68,0.35)]',
  };

  return (
    <button
      className={`${baseClasses} ${sizeClasses[size] || sizeClasses.md} ${variantClasses[variant] || variantClasses.primary} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
